import type { ViewCategory } from 'src/types/DeviceUI';
import { DEVICES_WITH_SINGLE_VIEW, DEVICES_WITH_MODE_RESTRICTED_VIEW } from 'src/constants';
import { deviceViewOptionsRegistry } from './view-registry';

/**
 * Maps a device mode/profile to the corresponding ViewCategory.
 * Only includes modes that are both passed from a profile-change component
 * AND belong to devices that have the "change view" setting.
 */
const MODE_TO_VIEW_CATEGORY: Record<string, ViewCategory> = {
	relay: 'relay',
};

/**
 * Determines whether the View Selection modal should be shown after a device
 * profile/mode change. Fully automatic — adding a new device/mode to the
 * existing config constants is enough; no changes to this file are needed
 * unless a brand-new mode string is introduced.
 *лl
 * @returns The ViewCategory to show the modal for, or `null` if no modal is needed.
 */
export function shouldShowViewSelectionOnModeChange(
	deviceType: string,
	newMode: string,
): ViewCategory | null {
	if (DEVICES_WITH_SINGLE_VIEW.includes(deviceType)) {
		return null;
	}

	const restrictedModes = DEVICES_WITH_MODE_RESTRICTED_VIEW[deviceType];
	if (restrictedModes?.includes(newMode)) {
		return null;
	}

	const category = MODE_TO_VIEW_CATEGORY[newMode];
	if (!category) {
		return null;
	}

	const options = deviceViewOptionsRegistry[category];
	if (!options || options.length < 2) {
		return null;
	}

	return category;
}
